var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgCodeIcon = function SvgCodeIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M8.1 0.301587C8.1 0.135025 8.23431 0 8.4 0H10.5C10.6657 0 10.8 0.135025 10.8 0.301587V2.4127C10.8 2.57926 10.6657 2.71429 10.5 2.71429H8.1V0.301587Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M5.4 3.01587C5.4 2.84931 5.53431 2.71429 5.7 2.71429H8.1V5.12698C8.1 5.29355 7.96569 5.42857 7.8 5.42857H5.4V3.01587Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M2.7 5.73016C2.7 5.5636 2.83431 5.42857 3 5.42857H5.4V7.84127C5.4 8.00783 5.26569 8.14286 5.1 8.14286H2.7V5.73016Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M0 8.44444C0 8.27788 0.134315 8.14286 0.3 8.14286H2.7V10.8571H0.3C0.134315 10.8571 0 10.7221 0 10.5556V8.44444Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M2.7 10.8571H5.1C5.26569 10.8571 5.4 10.9922 5.4 11.1587V13.5714H3C2.83431 13.5714 2.7 13.4364 2.7 13.2698V10.8571Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M5.4 13.5714H7.8C7.96569 13.5714 8.1 13.7065 8.1 13.873V16.2857H5.7C5.53431 16.2857 5.4 16.1507 5.4 15.9841V13.5714Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M8.1 16.2857H10.5C10.6657 16.2857 10.8 16.4207 10.8 16.5873V18.6984C10.8 18.865 10.6657 19 10.5 19H8.4C8.23431 19 8.1 18.865 8.1 18.6984V16.2857Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M18.9 0.301587C18.9 0.135025 18.7657 0 18.6 0H16.5C16.3343 0 16.2 0.135025 16.2 0.301587V2.4127C16.2 2.57926 16.3343 2.71429 16.5 2.71429H18.9V0.301587Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M21.6 3.01587C21.6 2.84931 21.4657 2.71429 21.3 2.71429H18.9V5.12698C18.9 5.29355 19.0343 5.42857 19.2 5.42857H21.6V3.01587Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M24.3 5.73016C24.3 5.5636 24.1657 5.42857 24 5.42857H21.6V7.84127C21.6 8.00783 21.7343 8.14286 21.9 8.14286H24.3V5.73016Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M27 8.44444C27 8.27788 26.8657 8.14286 26.7 8.14286H24.3V10.8571H26.7C26.8657 10.8571 27 10.7221 27 10.5556V8.44444Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M24.3 10.8571H21.9C21.7343 10.8571 21.6 10.9922 21.6 11.1587V13.5714H24C24.1657 13.5714 24.3 13.4364 24.3 13.2698V10.8571Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M21.6 13.5714H19.2C19.0343 13.5714 18.9 13.7065 18.9 13.873V16.2857H21.3C21.4657 16.2857 21.6 16.1507 21.6 15.9841V13.5714Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "illustration-main-fill",
    d: "M18.9 16.2857H16.5C16.3343 16.2857 16.2 16.4207 16.2 16.5873V18.6984C16.2 18.865 16.3343 19 16.5 19H18.6C18.7657 19 18.9 18.865 18.9 18.6984V16.2857Z",
    fill: "black"
  })));
};
export default SvgCodeIcon;